// Legacy database HTML and older pages have no source-level test IDs.
// Add stable, semantic IDs without changing their text, links or behavior.
export const addPresentationTestIds = (root, pathname) => {
  const slug = (value) => String(value).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 72);
  const page = slug(pathname) || "home";
  const used = new Set([...document.querySelectorAll("[data-testid]")].map((node) => node.dataset.testid));
  root.querySelectorAll("a, button, input, select, textarea, form, details, summary, [role], h1, h2, h3, h4, p, label, li, img, span, [class*='text-4xl']").forEach((node) => {
    if (node.hasAttribute("data-testid") || node.closest("svg")) return;
    const name = node.getAttribute("name") || node.getAttribute("aria-label") || node.id || node.getAttribute("href") || node.getAttribute("alt") || node.textContent.trim() || node.tagName;
    const base = `${page}-${slug(name)}-${node.tagName.toLowerCase()}`;
    let id = base;
    let suffix = 2;
    while (used.has(id)) id = `${base}-${suffix++}`;
    node.setAttribute("data-testid", id);
    used.add(id);
  });
};